import { DeleteFilled } from '@ant-design/icons';
import { Card, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import domainIcon from '../../assets/icons/domain_icon.svg';
import locationIcon from '../../assets/icons/info_3.svg';

import { Copy } from '../../components/Copy';

export const GpsItem = ({
  gps,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      title={<span className="speaker-title">{gps?.name}</span>}
      className="speaker-item"
      extra={
        <div className="speaker-extra">
          <div style={{ color: 'rgb(245, 47, 57)', gap: '5px' }}>
            <DeleteFilled
              onClick={() => {
                onRemove(gps.name, gps.serial);
              }}
            />
          </div>
        </div>
      }
    >
      <div className="speaker-info">
        <div className="info">
          <span style={{ marginRight: '10px' }}>
            <img src={domainIcon} className="img-icon" alt="Serial" />{' '}
            {t('Serial')}:
          </span>
          {`${gps.serial}` || '_'}
          <Copy content={`${gps.serial}`} />
        </div>
        <div className="info">
          <span>
            <img src={locationIcon} className="img-icon" alt="location" />{' '}
          </span>
          {gps.note || '_'}
        </div>
      </div>
      <Modal></Modal>
    </Card>
  );
};
